export enum ProductTypes {
  AdditionalProcessing = 'ADDITIONAL PROCESSING',
  Carpet = 'CARPET',
  Commission = 'COMMISSION',
  Cushion = 'CUSHION COVER',
  Delivery = 'DELIVERY',
  Extras = 'EXTRAS',
  Fabric = 'FABRIC',
  FabricTreatment = 'FABRIC TREATMENT',
  Furniture = 'FURNITURE',
  Headboard = 'HEADBOARD',
  Label = 'LABEL',
  Lining = 'LINING',
  PatternBooks = 'PATTERN BOOKS',
  Sample = 'SAMPLE',
  Sundry = 'SUNDRY',
  Trimming = 'TRIMMING',
  Wallpaper = 'WALLPAPER',
  Yarn = 'YARN',
}
